import {createContext} from "react"

const ContratoContext = createContext()

export default ContratoContext;